import textStyle from "./text.module.css"


export function QQQ() {
    return(
        <div className={textStyle['wrap']}>
            <h3>사고력수학 시매쓰 개인정보 수집·이용, 법정대리인 동의</h3>
            <div className="text">
                <strong>주식회사 오메가포인트(사고력수학 시매쓰)</strong> 다음과 같이 학원 운영 등을 위한 최소한의 개인정보를 수집하여 처리합니다.<br/>
                처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며,<br/>
                이용 목적이 변경되는 경우에는 「개인정보보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br/>
                또한 <strong>주식회사 오메가포인트</strong>는 개인정보를 제3자에게 제공하지 않으며,<br/>
                제공하게될 경우 별도의 동의를 받는 등 법령이 정하는 바에 따라 필요한 조치를 이행할 예정입니다.
                    
                <table className={textStyle['table']}>
                    <thead></thead>
                    <tbody>
                        <tr>
                            <th>수집하는 자</th>
                            <td colSpan="2"><strong>주식회사 오메가포인트</strong> (사고력수학 시매쓰)</td>
                        </tr>
                        <tr>
                            <th rowSpan="2">개인정보 수집·이용 목적</th>
                            <th>학원서비스</th>
                            <td>입학·퇴원, 상담, 학습내용, 공지사항, 학생 맞춤형 수업정보 등 학원 운영정보 전달</td>
                        </tr>
                        <tr>
                            <th>마케팅 및 광고</th>
                            <td>학원 행사 홍보 등 광고성 정보 전달</td>
                        </tr>
                        <tr>
                            <th>수집하는 개인정보 항목</th>
                            <td colSpan="2">
                                <ul>
                                    <li>
                                        진단테스트 예약 시 수집하는 개인정보
                                        <br/>
                                        <strong>학생</strong> 성명,
                                        <strong>학생</strong> 소속 교육기관(유치원, 학교 등),
                                        <strong>학생</strong> 학년,
                                        <strong>학생</strong> 생년월일,
                                        <strong>학부모(법정대리인)</strong> 휴대전화번호
                                    </li>
                                    <li>
                                        학원 등록 등 진단테스트 후 추가로 수집하는 개인정보
                                        <br/>
                                        <strong>학생</strong> 성별,
                                        <strong>학생</strong> 주소,
                                        <strong>학생</strong> 휴대전화번호,
                                        <strong>학생</strong> 나이,
                                        <strong>학부모(법정대리인)</strong> 성명,
                                        <strong>학부모(법정대리인)</strong> 전자우편주소,
                                        <strong>학부모(법정대리인)</strong>과 <strong>학생</strong> 간 관계
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th>개인정보 보유 및 이용기간</th>
                            <td colSpan="2">
                                <ul>
                                    <li>
                                        <strong>학원 등록 여부와 상관 없이 최신 교육정보·학원소식 전달, 학원 홍보 등을 위해 주식회사 오메가포인트가 위 개인정보를 보유 및 이용하는 것에 <u>동의하는 경우</u></strong>
                                        <br/>
                                        ⇒ <u>퇴원일로부터 5년 간</u>
                                    </li>
                                    <li>
                                        <strong>학원 등록 여부와 상관 없이 최신 교육정보·학원소식 전달, 학원 홍보 등을 위해 주식회사 오메가포인트가 위 개인정보를 보유 및 이용하는 것에 <u>동의하지 않는 경우</u></strong>
                                        <br/>
                                        ⇒ <u>퇴원일까지</u>
                                    </li>
                                    <li className="li-info">
                                        단, 「전자상거래법」, 「전자금융거래법」 등 다른 법령에서 정하는 바에 따라 개인정보를 의무적으로 보존해야하는 경우에는 해당 법령에서 정하는 기간 동안 개인정보를 보존합니다.
                                        <br/>
                                        (「개인정보 보호법」 제21조 1항)
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>

                <h2>1. 개인정보 수집 및 이용 동의</h2>
                <p>
                    귀하께는 동의하지 않을 권리가 있습니다.<br/>
                    동의하시지 않을 경우, <u>위 개인정보 수집·이용 목적에 포함된 학원 서비스 제공이 제한됨</u>을 알려드립니다.
                </p>
                <h2>2. 개인정보 마케팅 및 광고 활용 동의</h2>
                <p>
                    귀하께는 동의하지 않을 권리가 있으며, 마케팅 및 광고 활용에 동의하시지 않더라도 학원 서비스 이용에는 불이익이 없습니다.<br/>
                    다만, <u>동의하시지 않을 경우</u>, 학습·수업 등 학원 서비스 정보 외 <u><strong>학원행사, 신규강의 홍보 등에 관한 정보 제공</strong></u>이 제한됩니다.
                </p>
                <h2>3. 개인정보 보유기간에 관한 추가 동의</h2>
                <p>
                    <u><strong>최신 교육정보·학원소식 전달, 학원 홍보 등</strong></u>을 위해, 학원 등록 여부와 상관 없이,<br/>
                    즉 위 개인정보의 수집·이용 목적이 달성된 이후에도 퇴원일로부터 5년 간 위 개인정보를 보유 및 이용하는 것에 동의하시나요?<br/>
                    귀하께는 동의하지 않을 권리가 있으며, 동의하시지 않더라도 학원서비스 이용에는 불이익이 없습니다.<br/>
                    <u>동의하시지 않을 경우</u>, 학원 등록 상태가 아닐 때 <u><strong>최신 교육정보·학원소식 전달, 학원 홍보 등 정보 제공</strong></u>이 제한됩니다.
                </p>
                <h2>4. <span style={{fontWeight: "normal"}}>학생이 만 14세 미만 아동인 경우 법정대리인 동의가 필요합니다.</span></h2>
            </div>
        </div>
    )
}


export function Person() {
    return <QQQ></QQQ>
    return(
        <div>
            <div style={{marginBottom: "10px"}}>
                <div>개인정보보호법에 따라 (주)오메가포인트가 다음과 같이 개인정보를 수집, 이용함에 동의합니다. 동의하지 않으실 경우, 서비스 이용이 제한됩니다.</div>
            </div>
            <div>
                <div>- 수집하는 개인정보: 학생 이름, 성별, 학년, 학부모 전화번호, 주소</div>
                <div>- 개인정보 이용 목적: 신청 항목의 접수 및 서비스 이행, 이용 관련 안내</div>
                <div>- 개인정보 보관기간: 서비스 종료시까지(신청일로부터 최대 5년)</div>
            </div>
        </div>
    )
}

export function Transfer() {
    return <QQQ></QQQ>
    return(
        <div>
            <div style={{marginBottom: "10px"}}>
                <div>개인정보보호법에 따라 (주)오메가포인트가 다음과 같이 개인정보를 제3자에게 이전함에 동의합니다. 동의하지 않으실 경우, 서비스 이용이 제한됩니다.</div>
            </div>
            <div>
                <table style={{borderCollapse: "collapse"}}>
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공받는 자</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>신청 대상 지역 시매쓰 가맹점</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공 목적</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>신청 항목의 접수 및 서비스 이행, 이용 관련 안내, 마케팅 정보 발신</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공 항목</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>학생 이름, 성별, 학년, 학부모 전화번호, 주소</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>보관 기간</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>서비스 종료시까지(신청일로부터 최대 5년)</td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
            </div>
        </div>
    )
}

export function Promotion() {
    return <QQQ></QQQ>
    return(
        <div>
            <div>시매쓰에서 제공하는 이벤트/혜택 등 다양한 정보를 휴대전화로 받아보실 수 있습니다. 프로모션 정보 수신 동의는 이용자가 신청한 시매쓰 학원을 통해 언제든지 철회할 수 있습니다.</div>
        </div>
    )
}